import { Grid, Typography } from '@material-ui/core';
import { Box, Button } from '@superdispatch/ui-lab';
import { AddLoadAlertIcon } from 'shared/icons/AddLoadAlertIcon';
import styled from 'styled-components';
import { useSavedSearches } from '../../data/LoadboardSavedSearchesAPI';
import { SavedSearchEmptyCard } from '../SavedSearchEmptyCard';
import { SavedSearchListItem } from './SavedSearchListItem';

const Wrapper = styled.div`
  flex: 1 1;
  scroll-behavior: smooth;
`;

const Styled1 = styled.div`
  margin: 16px 8px;
`;
const Styled3 = styled(Grid)`
  text-align: center;
`;

interface SavedSearchListProps {
  onAddClick: () => void;
}

export function SavedSearchList({ onAddClick }: SavedSearchListProps) {
  const { data, error, refetch } = useSavedSearches();

  return (
    <Wrapper>
      <Styled1>
        <Grid container={true} spacing={2}>
          <Grid item={true} xs={12}>
            <Grid container={true} spacing={1}>
              {error ? (
                <Grid item={true} xs={12}>
                  <Typography align="center" color="textSecondary">
                    Oops! Something Went wrong.
                  </Typography>
                </Grid>
              ) : !data ? (
                <Grid item={true} xs={12}>
                  <Typography align="center" color="textSecondary">
                    Loading…
                  </Typography>
                </Grid>
              ) : data.length === 0 ? (
                <Grid item={true} xs={12}>
                  <Box padding="xsmall">
                    <SavedSearchEmptyCard onAddClick={onAddClick} />
                  </Box>
                </Grid>
              ) : (
                <>
                  {data.map((item) => (
                    <Grid key={item.guid} item={true} xs={12}>
                      <SavedSearchListItem
                        savedSearch={item}
                        refetchSavedSearches={() => {
                          void refetch();
                        }}
                      />
                    </Grid>
                  ))}
                  <Styled3 item={true} xs={12}>
                    <Button
                      variant="text"
                      fullWidth={true}
                      onClick={onAddClick}
                      startIcon={<AddLoadAlertIcon color="primary" />}
                    >
                      Create Load Alert
                    </Button>
                  </Styled3>
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Styled1>
    </Wrapper>
  );
}
